import { NewAnketa } from './NewAnketa';

export default NewAnketa;
